<template>
  <div class="contents_wrapper">
    <div class="contents">
      <h2 class="large_label">従業員登録</h2>

      <p class="bold_label">名字</p>
      <input type="text" class="text_form" v-model="newUserDetail.lastName"/>

      <p class="bold_label">名前</p>
      <input type="text" class="text_form" v-model="newUserDetail.firstName"/>

      <p class="bold_label">メールアドレス</p>
      <input type="text" class="text_form" v-model="authData.email"/>

      <p class="bold_label">パスワード</p>
      <input type="password" class="text_form" v-model="authData.password"/>

      <button @click="registerUser()" class="active-rectangle_button">従業員登録</button>
      <router-link class="underline_label" :to="{ name: 'Login'}">既に会員登録済みの方はこちら</router-link>
    </div>
  </div>
</template>

<script>
  import toast from '@/assets/js/functions/_core/toast';
  import users from '@/assets/js/functions/firebase/auth/users';
  import caller from "@/assets/js/functions/firebase/cloud_functions/caller";

  export default {
    name: "RegistrationStaff",

    mixins: [toast, users, caller],

    data() {
      return {
        officeId: '',

        authData: {
          email: '',
          password: '',
        },
        newUserDetail: {
          lastName: '',
          firstName: '',
          officeId: '',
        },
      }
    },

    created() {
      this.newUserDetail.officeId = location.pathname.replace('/auth/staff/registration_staff/', '');
      this.newUserDetail.officeId = this.newUserDetail.officeId.replace(/\/*$/, '');
    },

    methods: {
      isValidLogin() {
        if (!this.authData.email || !this.authData.password || !this.newUserDetail.lastName || !this.newUserDetail.firstName) {
          this.showErrorMessage('未入力の項目があります');
          return false;
        }
        return true;
      },

      async registerUser() {
        if (!this.isValidLogin()) return;

        const requestParam = {
          authData: this.authData,
          tempUserDetailData: this.newUserDetail,
        };

        await this.callFunction(
          'createStaffAccount',
          requestParam
        ).then(() => {
          this.showSuccessMessage('事務所オーナーから認証されるまでお待ちください。');
          this.$router.push({name: 'Top'});
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        });
      }
    },
  }

</script>

<style lang="scss" scoped>
  .contents_wrapper {
    > .contents {
      @include form-contents();
      align-items: center;
    }
  }
</style>
